// @flow

import React from "react";
import ReactDOM from "react-dom";

import Tweene from "tweene";
Tweene.defaultTimeUnit = "s";
Tweene.defaultDriver = "gsap";

const $ = window.$;

import { Blur, Flex, Text } from "@src/common";

import { Header, HeaderBody, HeaderTitle, HeaderInfo } from "./components";

class RiskHeader extends React.Component {
  // Component properties
  _hazardBodyRef: ReactClass<>;
  _hazardHeaderRef: ReactClass<>;
  _hazardHeaderIconRef: ReactClass<>;
  _hazardHeaderTimeline: Object;
  _rootBlurRef: ReactClass<>;

  constructor(props) {
    super(props);
    this.state = {
      hazardDialogOpened: false
    };
    this.onhazardDropdownClick = this.onhazardDropdownClick.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
  }

  componentDidMount() {
    // Initialize hazard timeline
    this._hazardHeaderTimeline = Tweene.line();

    // Save parent nodes used to animate
    const _rootBlurNode = ReactDOM.findDOMNode(this._rootBlurRef);

    // Header DOM nodes
    const _hazardHeaderNode = $(ReactDOM.findDOMNode(this._hazardHeaderRef));
    const _hazardHeaderIconNode = ReactDOM.findDOMNode(
      this._hazardHeaderIconRef
    );
    const _hazardBodyNode = $(ReactDOM.findDOMNode(this._hazardBodyRef));

    const hazardHeaderIconRotateTweene = Tweene.get(_hazardHeaderIconNode).to({
      rotate: "180deg"
    });

    const hazardHeaderHeightTweene = Tweene.get(_hazardHeaderNode).to({
      height: 40 + _hazardBodyNode.outerHeight()
    });

    const rootComponentOpacityTweene = Tweene.get(_rootBlurNode).to({
      display: "block",
      opacity: 0.7
    });

    this._hazardHeaderTimeline.add(hazardHeaderIconRotateTweene, 0);
    this._hazardHeaderTimeline.add(rootComponentOpacityTweene, 0);
    this._hazardHeaderTimeline.add(hazardHeaderHeightTweene, 0);
    this._hazardHeaderTimeline.add(() => {
      this.setState({ hazardDialogOpened: true });
    });
    this._hazardHeaderTimeline.on("reverse", () => {
      this.setState({ hazardDialogOpened: false });
    });
  }

  closeDropdown() {
    if (this.state.hazardDialogOpened) {
      this._hazardHeaderTimeline.reverse();
    }
  }

  onhazardDropdownClick() {
    if (this.state.hazardDialogOpened) {
      this._hazardHeaderTimeline.reverse();
    } else this._hazardHeaderTimeline.play();
  }

  render() {
    const {
      dialogTitle,
      dialogSubTitle,
      fontColor = "black",
      riskColor = "white"
    } = this.props;
    return (
      <div className="DialogWrapper">
        <Blur
          ref={ref => {
            this._rootBlurRef = ref;
          }}
          onClick={this.closeDropdown}
        />
        <Header
          ref={ref => {
            this._hazardHeaderRef = ref;
          }}
        >
          <HeaderTitle onClick={this.onhazardDropdownClick}>
            <HeaderInfo
              key="HeaderInfo"
              justifyContent="space-between"
              paddingH={3}
              backgroundColor={riskColor}
            >
              <Text type="medium" size={4} color={fontColor}>
                {dialogTitle}
              </Text>
              <Text type="medium" size={4} color={fontColor}>
                {dialogSubTitle}
              </Text>
            </HeaderInfo>
            <HeaderTitle backgroundColor="white" flex="initial" width="40px">
              <img
                ref={ref => {
                  this._hazardHeaderIconRef = ref;
                }}
                src={require("@public/assets/icons/minimal-down.svg")}
                alt=""
              />
            </HeaderTitle>
          </HeaderTitle>
          <Flex
            padding={3}
            ref={ref => {
              this._hazardBodyRef = ref;
            }}
          >
            <HeaderBody />
          </Flex>
        </Header>
      </div>
    );
  }
}

export default RiskHeader;



// WEBPACK FOOTER //
// ./src/containers/Assessment/components/RiskHeader/index.jsx